import { combineReducers } from 'redux';
import user from './user';
import header from './header';
import subheader from './subheader';
import open_menu from './open_menu';
import conversion from './conversion';
import contact_info from './contact_info';
import default_address from './default_address';
import code_send_at from './code-send-at';
import surcharge_title from './surcharge_title';
import referral_code from './referral-code';
import quote_before_login from './quote-before-login';

export const reducer = combineReducers({
    user,
    header,
    subheader,
    open_menu,
    conversion,
    contact_info,
    default_address,
    code_send_at,
    surcharge_title,
    referral_code,
    quote_before_login
});

export type RootState = ReturnType<typeof reducer>;

export default reducer;